import type { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function emailDomainMatchingValidator<K1 extends string, K2 extends string>(
  emailControl: K1,
  domainControl: K2,
): ValidatorFn {
  return (group: FormGroup<{ [k in K1 | K2]: FormControl<string> }>) => {
    const email = group.controls[emailControl];
    const domain = group.controls[domainControl];

    if (!email.value || !domain.value) {
      return null;
    }

    const emailTrimmed = email.value.split('@')[1];

    try {
      const url = new URL(domain.value);
      const domainTrimmed = url.hostname.replace(/^www\./, '');

      const isMismatch = emailTrimmed !== domainTrimmed;
      return isMismatch ? { domainEmailMismatch: true } : null;
    } catch (error) {
      return { domainEmailMismatch: true };
    }
  };
}
